import { Globe, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";

export function fareRows(form) {
  const ids = [form.origin_id, ...(form.stops || []).map((s) => s.station_id), form.destination_id].filter(Boolean);
  const old = form.fares || [];
  const rows = [];
  ids.forEach((a, i) => ids.slice(i + 1).forEach((b) => {
    const f = old.find((x) => x.from_id === a && x.to_id === b);
    rows.push({ from_id: a, to_id: b, fare: f ? f.fare : "", online: f ? f.online : true });
  }));
  return rows;
}

function FareRow({ r, i, name, set }) {
  const zero = !Number(r.fare);
  return (
    <div className={`grid grid-cols-[1fr_110px_auto] items-center gap-3 border-t border-slate-100 px-3 py-2 ${zero ? "bg-slate-50" : ""}`} data-testid={`fare-row-${i}`}>
      <div className="min-w-0 text-sm font-semibold">{name(r.from_id)} <span className="text-slate-400">→</span> {name(r.to_id)}
        {zero && <span className="ml-2 inline-flex items-center gap-1 text-[10px] font-bold uppercase text-slate-400"><EyeOff className="h-3 w-3" />Not sold</span>}
      </div>
      <Input type="number" min={0} value={r.fare} onChange={(e) => set(i, "fare", e.target.value)} placeholder="0" className="h-9 bg-white" data-testid={`fare-amount-${i}`} />
      <label className="flex items-center gap-2 text-xs font-semibold text-slate-600"><Switch checked={!!r.online} onCheckedChange={(v) => set(i, "online", v)} data-testid={`fare-online-${i}`} />Online</label>
    </div>
  );
}

export default function FareTable({ form, onChange, options }) {
  const rows = fareRows(form);
  const name = (id) => (options.find((o) => o.value === id)?.label || "?").split(" - ")[0];
  const set = (i, k, v) => onChange(rows.map((r, j) => (j === i ? { ...r, [k]: v } : r)));
  if (rows.length === 0) return <p className="text-xs text-slate-500">Pick the start and end stations first.</p>;
  return (
    <div className="space-y-2" data-testid="fare-table">
      <p className="flex items-start gap-1.5 text-xs text-slate-500"><Globe className="mt-0.5 h-3.5 w-3.5 shrink-0" />A fare of 0 is never sold. Fares above 0 show in all teller apps. With Online on, they also show on the public website and app.</p>
      <div className="overflow-hidden rounded-xl border border-slate-200">
        <div className="grid grid-cols-[1fr_110px_auto] gap-3 bg-slate-50 px-3 py-2 text-[10px] font-bold uppercase tracking-wider text-slate-500"><span>From → To</span><span>Fare (GH₵)</span><span>Allow online</span></div>
        {rows.map((r, i) => <FareRow key={`${r.from_id}-${r.to_id}`} r={r} i={i} name={name} set={set} />)}
      </div>
    </div>
  );
}
